// @flow
import * as React from 'react';

import { Container } from './styles';
import { debounce } from 'lodash/fp';
import { findDOMNode } from 'react-dom';

type Props = {
    children: ({ height: number, width: number }) => React.Element<any> | Array<React.Element<any>>,
    className?: string,
    debounce: number,
    onResize?: ({ height: number, width: number }) => void
};

type State = {
    height: number,
    width: number
};

export default class DOMResize extends React.Component<Props, State> {
    static defaultProps = {
        debounce: 500
    };

    state = {
        height: 0,
        width: 0
    };

    resizeParent: ?HTMLElement;

    handleResize = debounce(this.props.debounce, () => {
        if (!this.resizeParent) {
            return;
        }

        const node = findDOMNode(this.resizeParent);

        if (node && node instanceof HTMLElement) {
            const rect = node.getBoundingClientRect();
            const { onResize } = this.props;
            const sizes = { height: rect.height, width: rect.width };
            onResize && onResize(sizes);
            this.setState(sizes);
        }
    });

    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        this.handleResize.cancel();
        window.removeEventListener('resize', this.handleResize);
    }

    render() {
        const { children, className } = this.props;

        return (
            <Container className={className} ref={c => (this.resizeParent = c)}>
                {children({ ...this.state })}
            </Container>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/dom/dom-resize/index.js